document.addEventListener('DOMContentLoaded', function () {
  const splashScreen = document.getElementById('splash-screen');
  const menuScreen = document.getElementById('menu-screen');

  if (!splashScreen || !menuScreen) return;

  // Body scroll lock jab splash/menu active ho
  document.body.style.overflow = 'hidden';

  function showMenu() {
    splashScreen.classList.add('fade-out');

    setTimeout(function () {
      splashScreen.style.display = 'none';
      menuScreen.style.display = 'flex';

      requestAnimationFrame(function () {
        menuScreen.classList.add('fade-in');
      });
    }, 600);
  }

  function revealHomepage() {
    // Menu screen ko fade out karo
    menuScreen.classList.add('fade-out');

    setTimeout(function () {
      menuScreen.style.display = 'none';
      // Scroll wapas normal karo
      document.body.style.overflow = 'auto';
    }, 600);
  }

  // Splash pe click/keypress -> menu dikhao
  splashScreen.addEventListener('click', showMenu);
  document.addEventListener('keydown', function (e) {
    if (splashScreen.style.display !== 'none') {
      showMenu();
    }
  });

  // "Continue Game" link pe click -> overlay hatao, real homepage dikhao
  const continueGameLink = menuScreen.querySelector('.menu-item[data-continue="true"]');
  if (continueGameLink) {
    continueGameLink.addEventListener('click', function (e) {
      e.preventDefault();
      revealHomepage();
    });
  }
});